"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = require("../Modal");
var _Text = _interopRequireDefault(require("../Text/Text"));
var _ImageUploader = require("./ImageUploader.styles");
var _WebcamPreview = require("../WebcamPreview");
var ImageCameraUploaderModal = function ImageCameraUploaderModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    onComplete = _ref.onComplete;
  return /*#__PURE__*/_react["default"].createElement(_Modal.Modal, {
    title: "Add Picture",
    isOpen: isOpen,
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(_ImageUploader.ImageUploaderContainer, {
    style: {
      marginTop: '8px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    weight: "bold",
    style: {
      marginBottom: '16px',
      alignSelf: 'center'
    }
  }, "Take Picture from Camera"), /*#__PURE__*/_react["default"].createElement(_WebcamPreview.WebcamPreview, {
    width: 350,
    height: 350,
    onCapture: function onCapture(uri) {
      onComplete(uri);
      onClose();
    }
  })));
};
var _default = exports["default"] = ImageCameraUploaderModal;